import { Navigate } from "react-router-dom";
import { hasAnyPermission } from "../utils/premission";

interface ProtectedRouteProps {
  children: React.ReactNode;
  permissions?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, permissions }) => {
  const hasAccess = permissions ? hasAnyPermission(permissions) : true;

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;